import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import '../../styles/money.css';

// Print labels: who gets one on the left, the real sheet on the right.
export default function LabelsDesktop({ vm }) {
  const {
    canView, loading, functions, cards, chosen, picked, toggle, allOn, toggleAll,
    fnFilter, setFnFilter, typeFilter, setTypeFilter, q, setQ,
    withExtras, setWithExtras, startAt, setStartAt,
    stickers, slots, sheets, previewUrl, busy, savePdf, print,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Print labels</h1></div>
        <div className="card card-pad empty">You do not have access to the guests of this event.</div>
      </div>
    );
  }

  const on = (key) => !picked || picked.includes(key);

  return (
    <div>
      <div className="page-head">
        <h1>Print labels</h1>
        <span className="muted">{stickers} stickers · {sheets} {sheets === 1 ? 'sheet' : 'sheets'} of {slots}</span>
        <div className="spacer" style={{ flex: 1 }} />
        <Link className="btn light" to="/app/label-setup">⚙ Label setup</Link>
        <button className="btn light" disabled={!!busy || !chosen.length} onClick={print}>🖨 Print</button>
        <button className="btn primary" data-save="primary" disabled={!!busy || !chosen.length} onClick={savePdf}>↓ PDF</button>
      </div>

      <div className="lbl-print-layout mn-lbl-print">
        <div className="card card-pad">
          <div className="lbl-filters">
            <select value={fnFilter} onChange={e => setFnFilter(e.target.value)} title="Only cards invited to this function">
              <option value="">All functions</option>
              {functions.map(f => <option key={f.FunctionId} value={f.FunctionId}>{f.FunctionName}</option>)}
            </select>
            <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
              <option value="">Families and firms</option>
              <option value="Family">Families only</option>
              <option value="Business">Business associates only</option>
            </select>
            <input type="search" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)} />
          </div>

          <div className="lbl-options">
            <label className="lbl-check">
              <input type="checkbox" checked={withExtras} onChange={e => setWithExtras(e.target.checked)} />
              A sticker for each extra card too
            </label>
            <label className="field lbl-num">Start at sticker #
              <input type="number" min="1" max={slots || 1} value={startAt}
                onChange={e => setStartAt(Math.max(1, Math.min(Number(e.target.value) || 1, slots || 1)))} />
            </label>
            <button type="button" className="linklike" onClick={toggleAll}>{allOn ? 'untick all' : 'tick all'}</button>
          </div>

          {loading ? <Spinner /> : cards.length === 0 ? (
            <div className="empty">No invitation cards match this filter.</div>
          ) : (
            <div className="lbl-card-list">
              {cards.map(c => (
                <label key={c.key} className={'lbl-card-row' + (on(c.key) ? ' on' : '')}>
                  <input type="checkbox" checked={on(c.key)} onChange={() => toggle(c.key)} />
                  <span>
                    <strong>{c.name}</strong>
                    {c.type === 'Business' && c.subtitle && <span className="muted"> · {c.subtitle}</span>}
                    <span className="muted">
                      {c.city ? ` · ${c.city}` : ''}
                      {c.persons > 1 ? ` · family of ${c.persons}` : ''}
                      {c.extraCards > 0 ? ` · +${c.extraCards} extra` : ''}
                    </span>
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="card card-pad">
          <div className="step-label">The sheet as it will print</div>
          {busy === 'preview' || !previewUrl ? (
            <div className="lbl-preview-empty">
              {chosen.length ? <Spinner /> : 'Tick at least one card.'}
            </div>
          ) : (
            <iframe title="Label sheet preview" src={previewUrl} className="lbl-preview" />
          )}
          <div className="muted lbl-hint">
            Print at 100% — turn off “fit to page”, or every sticker shifts. The measurements live in Label setup.
          </div>
        </div>
      </div>
    </div>
  );
}
